// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"format-painter"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M10 16H14V21H10z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill1","fill":"transparent","d":"M4 3H19V6.5V10H4V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19 6.5V3H4V10H19V6.5ZM19 6.5H22V13H12V15","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 16H12H14V21H10V16Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-format-painter')
export default class FormatPainterIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'format-painter',
    }
  }
}
